export default {
  computed: {
    isLogged () {
      return !!this.$store.getters['auth/getProfile']
    }
  }
}
